import { z } from 'zod';

/**
 * How an organization's codebases are served, from its active subscription
 * row. `LEGACY` (every existing organization) waits for generated context and
 * shows every generation surface. `LITE` (self-serve signup) serves the
 * connected source alone, so the app strips to Investigations and the API
 * refuses generation. `FULL` (an organization staff upgraded by changing the
 * row) serves connected source and generates too. Nothing in the UI writes it.
 */
export const CONTEXT_MODES = ['LEGACY', 'LITE', 'FULL'] as const;

export type ContextMode = (typeof CONTEXT_MODES)[number];

export const contextModeSchema = z.enum(CONTEXT_MODES);

/**
 * The mode a response carries, or `LEGACY` when it carries none: a backend
 * from before the mode, or a value this build does not know. Today's
 * behaviour is the fail-open answer, so an existing organization never sees
 * its context UI disappear late.
 */
export function contextModeOf(value: string | null | undefined): ContextMode {
  const parsed = contextModeSchema.safeParse(value);
  return parsed.success ? parsed.data : 'LEGACY';
}
